export default "__VITE_ASSET__66843f31__"